import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { toastrNotify } from '../../utils/Toastr';
import { actionSignIn } from '../../actions/user';

const Login = ({ actionSignIn }) => {

   const handleSignIn = () => {
      let email    = document.querySelector('#email').value;
      let password = document.querySelector('#password').value;

      if ( email === '' || password === '' ) {
         toastrNotify({ typeMessage: 'warning', message: 'Es necesario ingresar el correo y contraseña', title : 'Validación' });
      } else {
         actionSignIn(email, password);
      }
      
   }

   return (
      <section className = "login-register">
         <div className = "login-box">
            <div className = "white-box">
               <form className = "form-horizontal form-material">
                  <h3 className = "box-title m-b-20"> Iniciar Sesión </h3>

                  <div className = "form-group">
                     <div className = "col-xs-12">
                        <input className = "form-control" id = "email" type = "text" placeholder = "correo electrónico" autoComplete='off' />
                     </div>
                  </div>

                  <div className = "form-group">
                     <div className = "col-xs-12">
                        <input className = "form-control" id = "password" type = "password" placeholder = "contraseña" autoComplete='off' />
                     </div>
                  </div>

                  <div className = "form-group">
                     <div className = "col-xs-12">
                        <button type = "button" className = "btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light" onClick = { handleSignIn }> Iniciar Sesión </button>
                     </div>
                  </div>

               </form>
            </div>
         </div>
      </section>
   )

};

function mapDispatchToProps ( dispatch ) {
   return bindActionCreators({
      actionSignIn
   }, dispatch)
}

export default connect(null, mapDispatchToProps)(Login);